export default {
  namespaced: true,

  state: {
    auth_checked: false,
    id: -1,
    id_fetched: false,
    user: {},
    user_fetched: false,
  },
  mutations: {
    checkAuth(state) {
      state.auth_checked = true
    },
    setId(state, user_id) {
      state.id = user_id
      state.id_fetched = !!user_id
    },
    setUser(state, user) {
      state.user = user
      state.user_fetched = !!user
    },
  },
  actions: {
    checkAuth(store) {
      store.commit('checkAuth')
    },
    login(store, id) {
      store.commit('setId', id)
    },
    logout(store) {
      store.commit('setId', false)
      store.commit('setUser', false)
    },
  },
}
